document.addEventListener('DOMContentLoaded', function () {
    const commitments = document.querySelectorAll('.commitments');
    commitments.forEach((commitment) => {
        const items = commitment.querySelectorAll('.commitments__item');
        const thumbs = commitment.querySelectorAll('.commitments__item-thumb');

        let timer = null;

        const resetTimer = () => {
            if (timer) clearTimeout(timer);

            const activeItem = document.querySelector('.commitments__item.active');
            if (activeItem && isElementInViewport(activeItem)) {
                timer = setTimeout(() => {
                    openNextItem();
                }, 10000);
            }
        };

        const openNextItem = () => {
            const activeItem = document.querySelector('.commitments__item.active');
            const activeThumb = document.querySelector('.commitments__item-thumb.active');
            let nextItem;
            let nextThumb;

            if (activeItem) {
                nextItem = activeItem.nextElementSibling || items[0];
                nextThumb = activeThumb.nextElementSibling || thumbs[0];
            } else {
                nextItem = items[0];
                nextThumb = thumbs[0];
            }

            switchToItem(nextItem, nextThumb);
            resetTimer();
        };

        const switchToItem = (newItem, newThumb) => {
            const activeThumb = document.querySelector('.commitments__item-thumb.active');
            const activeItem = document.querySelector('.commitments__item.active');

            if (newItem === activeItem) {
                return;
            }

            if (activeThumb) {
                activeThumb.classList.remove('animate__slideInLeft');
                activeThumb.style.position = 'absolute';
                activeThumb.classList.add('animate__slideOutRight');
                setTimeout(() => {
                    activeThumb.style = null;
                }, 950);
            }

            openItem(newItem, newThumb);
        };

        const closeAllItems = (currentItem) => {
            items.forEach((item, index) => {
                if (item === currentItem) {
                    return;
                }
                item.classList.remove('active');
                item.querySelector('.commitments__item-bar').classList.remove('visible');
                setTimeout(() => {
                    thumbs[index].classList.remove(
                        'active',
                        'wow',
                        'animated',
                        'animate__slideInLeft',
                        'animate__slideOutRight'
                    );
                }, 950);

                const description = item.querySelector('.commitments__item-description');
                if (description.style.height && description.style.height !== '0px') {
                    description.style.height = description.scrollHeight + 'px';
                    requestAnimationFrame(() => {
                        description.style.height = '0';
                    });
                }
            });
        };

        const openItem = (item, thumb) => {
            closeAllItems(item);

            const description = item.querySelector('.commitments__item-description');
            description.style.height = description.scrollHeight + 'px';
            const onTransitionEnd = (event) => {
                if (event.propertyName === 'height') {
                    description.style.height = 'auto';
                    description.removeEventListener('transitionend', onTransitionEnd);
                }
            };
            description.addEventListener('transitionend', onTransitionEnd);
            item.classList.add('active');
            thumb.style.position = 'static';
            setTimeout(() => {
                thumb.classList.add('wow', 'animated', 'animate__slideInLeft');
                thumb.classList.add('active');
                thumb.style = null;
            }, 150);
        };

        const isElementInViewport = (el) => {
            const rect = el.getBoundingClientRect();
            const isVisible =
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth);

            const itemBar = el.querySelector('.commitments__item-bar');
            if (itemBar) {
                if (isVisible) {
                    itemBar.classList.add('visible');
                } else {
                    itemBar.classList.remove('visible');
                }
            }

            return isVisible;
        };

        const checkVisibilityAndTimer = () => {
            const activeItem = document.querySelector('.commitments__item.active');
            if (activeItem && isElementInViewport(activeItem)) {
                resetTimer();
            } else if (timer) {
                clearTimeout(timer);
            }
        };

        openItem(items[0], thumbs[0]);

        items.forEach((item, index) => {
            if (index === 0) {
                openItem(item, thumbs[index]);
            }

            item.addEventListener('click', () => {
                switchToItem(item, thumbs[index]);
                resetTimer();
            });
        });

        window.addEventListener('scroll', checkVisibilityAndTimer);
        resetTimer();
    });
});
